import { ITransaction } from "interfaces/entities/transaction";
import { ActionsUnion, createAction } from "store/helper";

import { CRUDAction, RequestAction, createEntityActionNames, createRequestTypes } from "../actions";

import {
  ICreateTransactionFailurePayload,
  ICreateTransactionPayload,
  IMergeTransactionFailurePayload,
  IMergeTransactionPayload,
  IMergeTransactionSuccessPayload,
  ITransactionDeleteAttachmentFailurePayload,
  ITransactionDeleteAttachmentPayload,
  ITransactionDeleteAttachmentSuccessPayload,
  ITransactionFetchFailurePayload,
  ITransactionFetchSuccessPayload,
  ITransactionUploadAttachmentFailurePayload,
  ITransactionUploadAttachmentPayload,
  ITransactionUploadAttachmentSuccessPayload,
} from "./interfaces";

export const TRANSACTION = {
  ...createEntityActionNames("TRANSACTION"),
  UPLOAD_ATTACHMENT: createRequestTypes("ENTITIES/TRANSACTION/UPLOAD_ATTACHMENT"),
  DELETE_ATTACHMENT: createRequestTypes("ENTITIES/TRANSACTION/DELETE_ATTACHMENT"),
  MERGE_TRANSACTION: createRequestTypes("ENTITIES/TRANSACTION/MERGE"),
};

export const TransactionActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createTransaction: (payload: ICreateTransactionPayload) =>
    createAction(TRANSACTION.CREATE[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uploadAttachment: (payload: ITransactionUploadAttachmentPayload) =>
    createAction(TRANSACTION.UPLOAD_ATTACHMENT[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uploadAttachmentSuccess: (payload: ITransactionUploadAttachmentSuccessPayload) =>
    createAction(TRANSACTION.UPLOAD_ATTACHMENT[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  uploadAttachmentFailure: (payload: ITransactionUploadAttachmentFailurePayload) =>
    createAction(TRANSACTION.UPLOAD_ATTACHMENT[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteAttachment: (payload: ITransactionDeleteAttachmentPayload) =>
    createAction(TRANSACTION.DELETE_ATTACHMENT[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteAttachmentSuccess: (payload: ITransactionDeleteAttachmentSuccessPayload) =>
    createAction(TRANSACTION.DELETE_ATTACHMENT[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteAttachmentFailure: (payload: ITransactionDeleteAttachmentFailurePayload) =>
    createAction(TRANSACTION.DELETE_ATTACHMENT[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetch: (id: string) => createAction(TRANSACTION[CRUDAction.FETCH_SINGLE][RequestAction.REQUEST], { id }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchSuccess: (payload: ITransactionFetchSuccessPayload) =>
    createAction(TRANSACTION[CRUDAction.FETCH_SINGLE][RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchFailure: (payload: ITransactionFetchFailurePayload) =>
    createAction(TRANSACTION[CRUDAction.FETCH_SINGLE][RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createSuccess: (transaction: ITransaction) =>
    createAction(TRANSACTION[CRUDAction.CREATE][RequestAction.SUCCESS], { transaction }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createFailure: (payload: ICreateTransactionFailurePayload) =>
    createAction(TRANSACTION[CRUDAction.CREATE][RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  mergeTransaction: (payload: IMergeTransactionPayload) =>
    createAction(TRANSACTION.MERGE_TRANSACTION[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  mergeTransactionSuccess: (payload: IMergeTransactionSuccessPayload) =>
    createAction(TRANSACTION.MERGE_TRANSACTION[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  mergeTransactionFailure: (payload: IMergeTransactionFailurePayload) =>
    createAction(TRANSACTION.MERGE_TRANSACTION[RequestAction.FAILURE], payload),
};

export type TransactionAction = ActionsUnion<typeof TransactionActions>;
